import { render, staticRenderFns } from "./SithMesInventoryBinStatusList.vue?vue&type=template&id=2b18380a&"
import script from "./SithMesInventoryBinStatusList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryBinStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports